import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const ProductReviewsPage = lazy(
  () =>
    import('./ProductReviewsPage.eager').then(mod => ({
      default: mod.ProductReviewsPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
